"use client";

// Headless analytics for DexTools widget landings. It used to render the
// blocking mirror modals (DextoolsSignupModal for predictions,
// DextoolsCopyModal for copytrading) that repeated the card the visitor had
// just accepted on DexTools — an extra click and a "same thing again" feeling
// right where people close the tab. Those modals are gone: the real surface
// (sidebar buy panel, pre-selected by the deep-link `?outcome=`, or the trader
// profile) is now shown directly, Privy pops only on Buy/Copy (contextual
// signup), and the non-blocking <DextoolsLandingChip> next to the title keeps
// the partnership visible.
//
// This component stays mounted only to fire the `referral_landing` analytics
// once per session when a DexTools context (predictions OR copytrading) first
// appears. It renders nothing.

import { useEffect, useRef } from "react";
import { sendDextoolsEvent, detectAndStoreDextoolsUtm } from "@/lib/dextools-tracking";
import { useDextoolsSignupStore } from "@/stores/useDextoolsSignupStore";

const LANDING_KEY = "dextools_landing_sent";

export default function DextoolsWelcomeBanner() {
  // Predictions landing (event/market) and copytrading landing (trader profile)
  // populate SEPARATE store fields. Only one is ever non-null per page (the page
  // gates on its own campaign); either one is a genuine widget landing.
  const ctx = useDextoolsSignupStore((s) => s.ctx);
  const traderCtx = useDextoolsSignupStore((s) => s.traderCtx);
  const analyticsSentRef = useRef(false);

  // Fire `referral_landing` once per session, when a DexTools context first
  // appears (a genuine widget landing).
  useEffect(() => {
    if ((!ctx && !traderCtx) || analyticsSentRef.current) return;
    analyticsSentRef.current = true;
    try {
      const utm = detectAndStoreDextoolsUtm();
      if (utm && sessionStorage.getItem(LANDING_KEY) !== "1") {
        sessionStorage.setItem(LANDING_KEY, "1");
        sendDextoolsEvent({
          type: "referral_landing",
          utmSource: utm.utmSource,
          utmMedium: utm.utmMedium,
          utmCampaign: utm.utmCampaign,
          marketSlug: utm.marketSlug,
          variant: "auto_open",
        });
      }
    } catch { /* ignore */ }
  }, [ctx, traderCtx]);

  return null;
}
